import { stringify } from 'query-string';
import { env } from 'utils';

export const newsWebHost = env.isProductionApi ? 'https://news.stockplus.com' : '//news.dunamu-stock-dev.com';
export const quoteProdHost = 'https://quot-api-quant.stockplus.com';
export const quoteDevHost = 'https://quot-api.dunamu-gstockdev.com';
export const quoteHost = env.isProductionApi ? quoteProdHost : quoteDevHost;
export const quoteSummary = `${quoteHost}/v1/quant/fundamentals/public/summaries`;
export const newsProdHost = 'https://spn.stockplus.com';
export const newsDevHost = 'https://spn-dev.stockplus.com';
export const newsHost = env.isProductionApi ? newsProdHost : newsDevHost;
export const newsApi = `${newsHost}/news/api/v1/news`;
export const newsHot = '/hot_news';
export const mainProdHost = '//api.stockplus.com';
export const mainDevHost = 'https://api-dev.stockplus.com';
export const mainHost = env.isProductionApi ? mainProdHost : mainDevHost;
export const bannerGroups = `${mainHost}/v13/banner_groups`;
export const bannerScreenKeys = `${mainHost}/v13/banner_groups/screen_keys`;
export const fundamentalScoreTypes = `${quoteHost}/v1/quant/fundamentals/score_types`;
export const simpleData = `${mainHost}/v13/simple_data`;

export const buildNewsApi = (newsId: string) => {
  return `${newsApi}/${newsId}`;
};

export const buildNewsSummaryApi = (newsId: string) => {
  return `${newsApi}/${newsId}/summary`;
};

export const buildNewsHot = (shortenCode: string) => {
  return `${newsApi}/${shortenCode}${newsHot}`;
};

export const buildQuoteSummary = (shortenCodes: string[]) => {
  return `${quoteSummary}?${stringify({ shortCodes: shortenCodes })}`;
};

export const STOCKPLUS_ONELINK = 'https://stockplus.onelink.me/5C89';
export const buildViewAssetOneLink = (code: string) => {
  return `${STOCKPLUS_ONELINK}?af_dp=${encodeURIComponent(buildViewAssetScheme(code))}`;
};

export const buildViewStockOneLink = (code: string) => {
  return `${STOCKPLUS_ONELINK}?af_dp=${encodeURIComponent(buildViewStockScheme(code))}`;
};

export const buildViewAssetScheme = (code: string) => {
  return `stockplus://viewAsset?code=${code}`;
};

export const buildViewStockScheme = (code: string) => {
  return `stockplus://viewStock?code=${code}`;
};

export const buildFundamentalScheme = (code: string) => {
  return `${buildViewAssetScheme(code)}&tabName=analysis&tabIndex=4&subTabIndex=2`;
};

export const buildFundamentalOneLink = (code: string) => {
  return `${STOCKPLUS_ONELINK}?af_dp=${encodeURIComponent(buildFundamentalScheme(code))}`;
};

export const buildFundamentalOneLinkForIos = (code: string) => {
  return `${STOCKPLUS_ONELINK}?af_dp=${encodeURIComponent(
    `${buildViewStockScheme(code)}&tabName=analysis&tabIndex=4&subTabIndex=2`,
  )}`;
};

// 15분 delay 되는 마켓들 리스트
export const delayedMarketList = ['NYS', 'AMX', 'NAS', 'NAI', 'DJI', 'SPI'];

const STORAGE_KEY_PREFIX = 'STOCKPLUS';
const STORAGE_KEY_SERVICE = 'NEWS';
export const StorageKey = {
  ShowSummary: `${STORAGE_KEY_PREFIX}_${STORAGE_KEY_SERVICE}_SHOW_SUMMARY`,
  ShowSummaryTooltip: `${STORAGE_KEY_PREFIX}_${STORAGE_KEY_SERVICE}_SHOW_SUMMARY_TOOLTIP`,
};
